import React from "react";
import classNames from "classnames";
import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import "./SimpleHead.styles.scss";

interface Props {
  children?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  onIconClick?: () => void | Promise<void>;
  icon?: JSX.Element;
}

export const SimpleHead: React.FC<Props> = ({ children, className = "", onIconClick, icon, titleClassName }) => {
  return (
    <div className={classNames("simple-head", { [className]: !!className })}>
      <span className={classNames("title", { titleClassName: !!titleClassName })}>{children || "Simple Head"}</span>
      <IconButton size="sm" onClick={onIconClick}>
        {icon ? icon : <Close sx={{ fontSize: "20px", color: "#0a3142" }} />}
      </IconButton>
    </div>
  );
};
